export enum KeyboardKeysEnum {
   Backspace = "Backspace",
   Tab = "Tab",
   Enter = "Enter",
   Shift = "Shift",
   Control = "Control",
   Alt = "Alt",
   CapsLock = "CapsLock",
   Escape = "Escape",
   Space = "Space",
   PageUp = "PageUp",
   PageDown = "PageDown",
   End = "End",
   Home = "Home",
   ArrowLeft = "ArrowLeft",
   ArrowUp = "ArrowUp",
   ArrowRight = "ArrowRight",
   ArrowDown = "ArrowDown",
   Insert = "Insert",
   Delete = "Delete",
   Digit0 = "Digit0",
   Digit1 = "Digit1",
   Digit2 = "Digit2",
   Digit3 = "Digit3",
   Digit4 = "Digit4",
   Digit5 = "Digit5",
   Digit6 = "Digit6",
   Digit7 = "Digit7",
   Digit8 = "Digit8",
   Digit9 = "Digit9",
   KeyA = "KeyA",
   KeyB = "KeyB",
   KeyC = "KeyC",
   KeyD = "KeyD",
   KeyE = "KeyE",
   KeyF = "KeyF",
   KeyG = "KeyG",
   KeyH = "KeyH",
   KeyI = "KeyI",
   KeyJ = "KeyJ",
   KeyK = "KeyK",
   KeyL = "KeyL",
   KeyM = "KeyM",
   KeyN = "KeyN",
   KeyO = "KeyO",
   KeyP = "KeyP",
   KeyQ = "KeyQ",
   KeyR = "KeyR",
   KeyS = "KeyS",
   KeyT = "KeyT",
   KeyU = "KeyU",
   KeyV = "KeyV",
   KeyW = "KeyW",
   KeyX = "KeyX",
   KeyY = "KeyY",
   KeyZ = "KeyZ",
   F1 = "F1",
   F2 = "F2",
   F3 = "F3",
   F4 = "F4",
   F5 = "F5",
   F6 = "F6",
   F7 = "F7",
   F8 = "F8",
   F9 = "F9",
   F10 = "F10",
   F11 = "F11",
   F12 = "F12",
   Num0 = "Num0",
   Num1 = "Num1",
   Num2 = "Num2",
   Num3 = "Num3",
   Num4 = "Num4",
   Num5 = "Num5",
   Num6 = "Num6",
   Num7 = "Num7",
   Num8 = "Num8",
   Num9 = "Num9",
   NumMultiply = "NumMultiply",
   NumAdd = "NumAdd",
   NumSubtract = "NumSubtract",
   NumDecimal = "NumDecimal",
   NumDivide = "NumDivide",
   NumLock = "NumLock",
   ScrollLock = "ScrollLock",
   Semicolon = "Semicolon",
   Equal = "Equal",
   Comma = "Comma",
   Minus = "Minus",
   Period = "Period",
   Slash = "Slash",
   Backquote = "Backquote",
   BracketLeft = "BracketLeft",
   Backslash = "Backslash",
   BracketRight = "BracketRight",
   Quote = "Quote"
}
